import React, { useState } from 'react';
import {
  TextField, Button, Select, MenuItem, FormControl, InputLabel, Checkbox, ListItemText, Box, Typography,
} from '@mui/material';
import { registerClient, updateClient } from '../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

const vendorsList = [
  'evolution', 'sports', 'pragmaticlive', 'netent', 'ezugi', 'spribe', 'km', 'hacksaw',
  'pragmatic', 'ideal', 'microgaming', 'dpesports', 'pgsoft', '2j', 'jili',
];

const ClientForm: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = location.state?.client;

  const [formData, setFormData] = useState({
    client_name: client?.client_name || '',
    callback_url: client?.callback_url || '',
    currency: client?.currency || 'USD',
    initial_balance: client?.balance || 0,
    username: client?.username || '',
    password: client?.password || '',
    ggr_percentage: client?.ggr_percentage || 15.00,
    status: client?.status || 'active',
    client_id: client?.id || undefined,
    vendors: client?.vendors || vendorsList,
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleVendorChange = (event: any) => {
    setFormData({ ...formData, vendors: event.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (client) {
        await updateClient(formData);
      } else {
        await registerClient(formData);
      }
      navigate('/superadmin/clients');
    } catch (err) {
      console.error('Failed to save client', err);
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar role="superadmin" />
      <Box sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Typography variant="h4" gutterBottom>
          {client ? 'Edit Client' : 'Add Client'}
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Client Name"
            name="client_name"
            value={formData.client_name}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Callback URL"
            name="callback_url"
            value={formData.callback_url}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Currency"
            name="currency"
            value={formData.currency}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Initial Balance"
            name="initial_balance"
            type="number"
            value={formData.initial_balance}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleChange}
            fullWidth
            margin="normal"
            disabled={!!client}
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
            disabled={!!client}
          />
          <TextField
            label="GGR Percentage"
            name="ggr_percentage"
            type="number"
            value={formData.ggr_percentage}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          {client && (
            <FormControl fullWidth margin="normal">
              <InputLabel>Status</InputLabel>
              <Select name="status" value={formData.status} onChange={handleChange}>
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          )}
          <FormControl fullWidth margin="normal">
            <InputLabel>Vendors</InputLabel>
            <Select
              multiple
              value={formData.vendors}
              onChange={handleVendorChange}
              renderValue={(selected) => (selected as string[]).join(', ')}
            >
              {vendorsList.map((vendor) => (
                <MenuItem key={vendor} value={vendor}>
                  <Checkbox checked={formData.vendors.indexOf(vendor) > -1} />
                  <ListItemText primary={vendor} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button type="submit" variant="contained" color="primary" sx={{ mt: 2 }}>
            {client ? 'Update' : 'Add'} Client
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default ClientForm;